export const SET_GROUPS = (state, payload) => (state.items = payload);
export const SET_GROUP_MATCH = (state, payload) => (state.match = payload);
